export class TypeBien {

    tpb_id: string;
    tpb_code: string;
    tpb_parent: string;
    tpb_libelle: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.tpb_id                     = data['tpb_id'] ? data['tpb_id'] : null;
        this.tpb_code                   = data['tpb_code'] ? data['tpb_code'] : null;
        this.tpb_parent                 = data['tpb_parent'] ? data['tpb_parent'] : null;
        this.tpb_libelle                = data['tpb_libelle'] ? data['tpb_libelle'] : null;
    }

}
